<div class="blanco"></div>
<footer class="footer_in">
    <div class="row">
        <div class="col-md-9">
            <div class="copy-right">
                <ul>
                    <li [routerLinkActive]='["link-active"]'><a [routerLink]='[""]'>{{"barraNavegacion.Inicio" | translate}}</a></li>
                    <li><a href="#">{{"barraNavegacion.Sarlaft" | translate}}</a></li>
                    <li><a href="#">{{"barraNavegacion.Siniestros" | translate}}</a></li>
                    <li><a href="#">{{"barraNavegacion.PACs" | translate}}</a></li>
                    <li><a href="#">{{"barraNavegacion.Administracion" | translate}}</a></li>
                    <li><a href="#">{{"barraNavegacion.Configuracion" | translate}}</a></li>
                    <li><a href="#">{{"barraNavegacion.TableroControl" | translate}}</a></li>
                </ul>
            </div>
        </div>
        <div class="col-md-3">
            <div class="social-icons">
                <ul class="top-icons">
                    <li><a href="https://www.linkedin.com/company/willis-towers-watson"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    <li><a href="https://twitter.com/WTWcorporate"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                    <li><a href="https://www.facebook.com/Willis-Towers-Watson-213983474385/?fref=ts"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>


                </ul>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
    <div class="col-md-12">
        <div class="footer_in-border"></div>
    </div>
    <div class="copy-right">
        <ul>
            <li><a href="https://www.willistowerswatson.com/es-ES/Notices/terms-of-use" target="_blank">{{"barraNavegacion.Footer.TerminosUso" | translate}}</a></li>
            <li><a href="https://www.willistowerswatson.com/es-ES/Notices/global-website-privacy-notice" target="_blank">{{"barraNavegacion.Footer.PoliticaPrivacidad" | translate}}</a></li>
        </ul>
    </div>
    <div class="copy-2">
        <p class="footer-gd">{{"barraNavegacion.Footer.CopyRigth" | translate}}</p>
    </div>

</footer>